import styled from 'styled-components';

export const MessageWrapperChooseContract = styled.div`
  background-color: #efefef;
  height: 33rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Message = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
